<template>
  <div>
    <modal-template
      v-show="toggle"
      @close="toggleInfoModal"
      class="override-modal"
    >
      <template #header>
        <i class="icon-ic_close" @click="toggleInfoModal" />
        <h3>{{ $t('agenda.ausencia') }}</h3>
      </template>
      <template #body>
        <div class="has-text-centered">
          <p>{{ $t('agenda.ausencia-orientacao') }}</p>
        </div>
      </template>
      <template #footer>
        <div class="columns absence">
          <b-button class="column cancel" @click="toggleInfoModal">
            {{ $t('botoes.cancelar') }}
          </b-button>
          &nbsp;
          <b-button class="column confirm" @click="redirectToChat()">
            {{ $t('botoes.chat') }}
          </b-button>
        </div>
      </template>
    </modal-template>
  </div>
</template>

<script>
import ModalTemplate from '../modal/ModalTemplate'
export default {
  name: 'AbsenceModal',
  components: { ModalTemplate },
  props: {
    toggle: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleInfoModal() {
      this.$emit('closeModal', 'absenceModal')
    },
    redirectToChat() {
      window.open('http://www.sarah.br/chat')
      this.$emit('closeModal', 'absenceModal')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
.absence {
  margin-bottom: 4px;
  margin: 0 auto;
  width: 90%;

  .confirm {
    margin: auto;
    box-sizing: border-box;
    height: 2.5rem;
    width: 12.5rem;

    color: var(--orange-dark);
    border: 0.0625rem solid $orange-dark;
    border-color: var(--orange-dark);
    border-radius: 0.25rem;

    &:hover {
      color: var(--neutral-color-5);

      background-color: var(--orange-dark);
      transition: all 0.2s;
    }
  }

  .cancel {
    color: var(--light-blue);
    font-weight: 500;
    font-size: 0.875rem;
    height: 2.5rem;
    border: 1px solid rgba(0, 105, 180, 0.2);
  }
}
</style>
